
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customlistadodedestacadosenventaplwyh_67c867e2a9c8dc86c6729608, customlistadodeinmueblesenventa91b9j_67c86946a9c8dc86c672972a } from '../../api/inmuebles5x55o.api'

import './inmueblesenventap1coy.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pinmueblesenventap1coy = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_67c867e2a9c8dc86c6729608_component_i1cm2l, setloftyres_67c867e2a9c8dc86c6729608_component_i1cm2l] = useState([]);
	const [loftyres_67c86946a9c8dc86c672972a_component_it0maz, setloftyres_67c86946a9c8dc86c672972a_component_it0maz] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodedestacadosenventaplwyh_67c867e2a9c8dc86c6729608({
				});
				setloftyres_67c867e2a9c8dc86c6729608_component_i1cm2l(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodeinmueblesenventa91b9j_67c86946a9c8dc86c672972a({
				});
				setloftyres_67c86946a9c8dc86c672972a_component_it0maz(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id676f048edf08e4838cb8874f" >

      <div id="iw4j" className="">
      
      <div id="i7iuy6" className="">
      
      <div id="ikooaf" className="">
      
      <span className="material-icons " id="iv5d9d">
        
      <span className="material-icons " id="iqcwn3">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="iwehdy">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijj06m">
        <>(+504) 9452-3409 </>
      </span>
      
      </div>
      
      <div className="" id="iws54s">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9drhg">
        <>(+504) 3292-8788</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56xoug0.png"
        alt="undefined"
      />
      
      <div id="ifvvzp" className="">
      
      <a
        target=""
        className=""
        id="inedox"
        href="/"
        type="button"
      >
        
    <div id="iclrrs" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iacjt4"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ivmnu1" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
        <LoftyDropdownComponent
          id="iuz4oz"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iii6zp" className="gjs-dropdown-menu-trigger ">
<>Inmuebles</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ik6gsu" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className="link "
          id="iwvm7a"
          href={`/inmueblesenrenta`}
        >
          
    <div id="i5c0jk" className="">
    <>En Renta</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link "
          id="ijfa93"
          href="#"
        >
          
    <div id="i1ld0p" className="">
    <>En Venta</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
      <a
        target=""
        className=""
        id="ih0w28"
        href="/contacto"
        type="button"
      >
        
    <div id="i89xkj" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre Nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenrenta"
        type=""
      >
        <>Inmuebles en Renta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/inmueblesenventa"
        type=""
      >
        <>Inmuebles en Venta</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icx7ut" className="">
      
      <div className="" id="ij68c3">
        <>En Venta</>
      </div>
      
      </div>
      
      <div id="ipvnvk" className="">
      
      <div id="iizvzq" className="">
      
      <div className="" id="ii21mb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="igaar5">
        <>Destacados de la semana</>
      </span>
      
      </div>
      
      </div>
      
      <div id="ip8fff" className="">
      
        <div id="i1cm2l" className="">
        
            {
              loftyres_67c867e2a9c8dc86c6729608_component_i1cm2l.map((loftyitem_67c867e2a9c8dc86c6729608_component_i1cm2l) => (
                <div key={loftyitem_67c867e2a9c8dc86c6729608_component_i1cm2l._id} className="" id="iyejza">
                  
      <div
        id="i4fl6d"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <img
          className=""
          id="iadf54"
          alt=""
          src={loftyitem_67c867e2a9c8dc86c6729608_component_i1cm2l.loftyUrl}
        />
        
      <div id="i1g04n" className="">
      
        <div className="" id="imqe11">
          
          <div className="" id="">
            {loftyitem_67c867e2a9c8dc86c6729608_component_i1cm2l?.titulop4an9}
          </div>
          
        </div>
        
      </div>
      
      <div id="i1o8r4" className="">
      
        <a
          target=""
          className=""
          id="i1ovcd"
          href="#"
        >
          
      <span className="" id="ixsnr1">
        <>Visualizar detalles</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      <div id="if2bve" className="">
      
      <div id="ijuxs3" className="">
      
      <div className="" id="ies4dr">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih6c8d">
        <>Propiedades Recientes</>
      </span>
      
      </div>
      
      </div>
      
      <div id="i20udp" className="">
      
        <div id="it0maz" className="">
        
            {
              loftyres_67c86946a9c8dc86c672972a_component_it0maz.map((loftyitem_67c86946a9c8dc86c672972a_component_it0maz) => (
                <div key={loftyitem_67c86946a9c8dc86c672972a_component_it0maz._id} className="" id="ijfcze">
                  
      <div
        id="i3piqh"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
        <img
          className=""
          id="ing277"
          alt=""
          src={loftyitem_67c86946a9c8dc86c672972a_component_it0maz.loftyUrl}
        />
        
      <div id="i9xa7y" className="">
      
        <div className="" id="i8fm61">
          
          <div className="" id="">
            {loftyitem_67c86946a9c8dc86c672972a_component_it0maz?.titulop4an9}
          </div>
          
        </div>
        
      </div>
      
      <div id="i41u6w" className="">
      
        <a
          target=""
          className=""
          id="i54nsl"
          href="#"
        >
          
      <span className="" id="ihcwz2">
        <>Visualizar detalles</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      </div>
      
      <div id="ikukgf" className="">
      
      <div id="i1qiq6" className="">
      
      </div>
      
      <div id="i28lhh" className="">
      
      <div id="inehij" className="">
      
      <div className="" id="i2p8fx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6lug4">
        <>¿Planea arrendar o vender su inmueble?</>
      </span>
      
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="ivq6og"
          href="/contacto"
        >
          
      <span className="" id="inw7ed">
        <>Contáctanos</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      <div id="il4d9o" className="">
      
      <div id="ioigc7" className="">
      
      <div id="ir2su1" className="">
      
      <img
        className=""
        id="imr6xn"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z3fz2.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iip0hj" className="">
      
      <div id="icdzzf" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Sobre Nosotros</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ig1at"
        href="/contacto"
        type="button"
      >
        
    <div id="isq53" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      <div id="inxorr" className="">
      
      <img
        className=""
        id="iib493"
        src="https://assetsprojects.s3.amazonaws.com/404ofwim56z589z.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i9jwhn">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilrddl">
        <>Teléfono: +504 33445633 
Correo electrónico: informacion@grupodor.com 
Dirección: </>
      </span>
      
      <span className="" id="iiolky">
        <>Colonia Universidad, 24 calle, 9 avenida, Plaza Bulevares, San Pedro Sula, Cortés, Honduras C.A.</>
      </span>
      
      </div>
      
      <div id="ikrieu" className="">
      
        <a
          target="_blank"
          className=""
          id="iugvxb"
          href="https://www.facebook.com/DORInmobiliariaHN/?_rdr"
        >
          
      <span className="" id="ifk2kr">
        <>Facebook</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="iewo54"
          href="https://www.instagram.com/dorinmobiliaria"
        >
          
      <span className="" id="ig11q1">
        <>Instagram</>
      </span>
      
        </a>
        
        <a
          target="_blank"
          className=""
          id="ixgr5i"
          href="https://www.linkedin.com/company/dor-inmobiliaria/"
        >
          
      <span className="" id="iz2xzh">
        <>LinkedIn</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="imier2" className="">
      
      <div id="i50ldy" className="">
      
      </div>
      
      <div id="igphyo" className="">
      
      <div className="" id="i1gmf4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iy1e52">
        <>DOR © 2024. Todos los derechos reservados</>
      </span>
      
      </div>
      
      <div className="" id="ids74n">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="izx0i8">
        <>Términos de uso</>
      </span>
      
      </div>
      
      <div className="" id="i6pgi9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itfy23">
        <>Políticas de privaciad</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinmueblesenventap1coy);
  